var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-mpindex"},[_c('MpNavbar'),_c('MpTitle',{attrs:{"title":"欢迎使用GiiLoo咖啡杯测","intro":"点击左侧导航栏进入所选功能"}}),_c('div',{staticClass:"intro-left"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }